export const common = {
  nav: {
    services: 'Services',
    packages: 'Packages',
    about: 'About',
    testimonials: 'Testimonials',
    bookNow: 'Book Now',
    phone: '+34 643 939 427',
  },
  hero: {
    badge: 'Premium Home Services Since 2020',
    title: 'Transform Your Space Into a Sanctuary',
    subtitle: 'Expert interior design, meticulous cleaning, reliable maintenance, and custom renovations—all under one roof',
    exploreServices: 'Explore Services',
    viewPackages: 'View Packages',
  },
  services: {
    title: 'Our Expertise',
    subtitle: 'Comprehensive home solutions tailored to your lifestyle',
    learnMore: 'Learn More',
    interiorDesign: 'Interior Design',
    cleaning: 'Cleaning',
    maintenance: 'Maintenance',
    renovation: 'Renovation',
  },
  pricing: {
    title: 'Service Pricing',
    subtitle: 'Transparent pricing for all property sizes',
    serviceType: 'Service Type',
    bedroom1: '1 Bedroom',
    bedroom2: '2 Bedroom',
    bedroom3: '3 Bedroom',
    villa: 'Villa',
    cleaningServices: 'Cleaning Services',
    cleaningDesc: 'Post-stay cleaning',
    maintenance: 'Maintenance',
    maintenanceDesc: 'Plumbing checks & minor repairs',
    interiorDesign: 'Interior Design',
    interiorDesignDesc: 'Design consultation',
    perMonth: 'per month',
    allPricesInclude: 'All prices include standard features and services',
    getQuote: 'Get a Quote',
  },
  packages: {
    badge: 'Curated Bundles',
    title: 'Service Packages',
    subtitle: 'Pre-designed solutions for vacation rentals and permanent residents',
    selectPackage: 'Select Package',
    perService: '/ per service',
    perMonth: '/ month',
    customPricing: 'Pricing depends on project scope',
    mostPopular: 'Most Popular',
    bestValue: 'Best Value',
    bookService: 'Book Service',
    includes: 'Includes:',
    serviceColumns: {
      cleaning: {
        title: 'Cleaning Services',
        subtitle: 'Apartments & Villas',
        description: 'Our cleaning service ensures your property is guest-ready, hygienic, and professionally maintained.',
        includes: [
          'Post-stay cleaning for vacation rentals',
          'Deep cleaning of all rooms',
          'Kitchen cleaning (surfaces, appliances, cabinet exteriors)',
          'Bathroom sanitization (toilets, showers, sinks, mirrors)',
          'Floor cleaning (sweeping, mopping, vacuuming)',
          'Dusting of furniture and surfaces',
          'Linen change & laundry coordination',
          'Restocking essentials (toilet paper, soap, basic supplies)',
          'Final inspection to ensure guest-ready condition',
        ],
      },
      maintenance: {
        title: 'Maintenance Services',
        subtitle: 'Preventive & Corrective',
        description: 'Our maintenance service keeps your property functional, safe, and issue-free, preventing costly emergency repairs.',
        includes: [
          'Plumbing checks & minor repairs (leaks, taps, drains)',
          'Electrical inspections & small fixes (switches, lights, outlets)',
          'AC inspection & filter cleaning',
          'Appliance check (washing machine, fridge, oven, boiler)',
          'Door, window, lock & hinge adjustments',
          'Minor carpentry repairs',
          'Paint touch-ups & wall repairs',
          'General wear-and-tear fixes',
          'Regular property condition checks & reports',
        ],
      },
      interiorDesign: {
        title: 'Interior Design & Renovation Services',
        subtitle: null,
        description: 'Our interior design & renovation service enhances the comfort, aesthetics, and rental value of your property.',
        includes: [
          'Interior design consultation',
          'Space planning & layout optimisation',
          'Furniture selection & placement',
          'Lighting recommendations & upgrades',
          'Colour palettes & material selection',
          'Styling & staging for vacation rentals',
          'Rental-ready aesthetic upgrades',
          'Seasonal décor updates',
          'Coordination of renovation works (painting, carpentry, minor improvements)',
        ],
      },
      renovation: {
        title: 'Renovation',
        subtitle: 'Light to Medium',
        description: 'For improvements and upgrades without full construction.',
        includes: [
          'Painting & wall finishes',
          'Carpentry upgrades (cabinets, shelving, custom solutions)',
          'Kitchen & bathroom improvements',
          'Flooring upgrades',
          'Functional & aesthetic enhancements',
          'Project coordination with trusted local tradespeople',
        ],
      },
    },
    items: {
      postStay: {
        name: 'Pre/Post-Stay Refresh',
        features: [
          'Deep cleaning (3–4 hours)',
          'Linen change & laundry',
          'Minor repairs & touch-ups',
          'Restocking essentials',
          'Quick property check',
        ],
      },
      villaPrep: {
        name: 'Pre/Post Stay Villa Preparation',
        features: [
          'Interior styling consultation',
          'Complete deep cleaning',
          'Maintenance check',
          'Welcome setup & staging',
          'Property inspection',
        ],
      },
      monthlyRefresh: {
        name: 'Monthly Home Refresh',
        features: [
          '2–4 visits per month',
          'Weekly or bi-weekly cleaning',
          'Basic maintenance check',
          'Appliance checks',
          'Tidy & hygienic home',
        ],
      },
      interiorDesign: {
        name: 'Interior Design & Styling',
        features: [
          'Consultation with Art Throng design experts',
          'Full interior styling or small updates for residents or rentals',
          'Integration with cleaning and maintenance schedules',
          'Optional staging for vacation rentals',
        ],
      },
    },
  },
  booking: {
    title: 'Book Your Service',
    subtitle: 'Fill out the form and we\'ll get back to you soon',
    form: {
      service: 'Select Service',
      servicePlaceholder: 'Choose a service',
      date: 'Preferred Date',
      time: 'Preferred Time',
      frequency: 'Frequency',
      frequencyPlaceholder: 'Select frequency',
      name: 'Full Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone',
      phonePlaceholder: 'Your phone number',
      message: 'Message (Optional)',
      messagePlaceholder: 'Tell us about your needs...',
      submit: 'Submit Booking',
      submitting: 'Submitting...',
      success: 'Booking submitted successfully! We\'ll be in touch soon.',
      error: 'Something went wrong. Please try again.',
    },
    services: {
      interior: 'Interior Design',
      cleaning: 'Home Cleaning',
      maintenance: 'Maintenance',
      renovation: 'Renovation & Carpentry',
    },
    frequencies: {
      oneTime: 'One-Time',
      weekly: 'Weekly',
      biweekly: 'Bi-weekly',
      monthly: 'Monthly',
    },
  },
  about: {
    badge: 'Who We Are',
    title: 'About',
    paragraph1: 'Art Throng offers complete interior and exterior design solutions, delivering accessible luxury and adapting to all design styles for clients across the Canary Islands.',
    paragraph2: 'We\'ve been based in Fuerteventura for the past five years, building a trusted local presence and assembling a skilled team of carpenters, albañiles (masons), painters, and now cleaning and maintenance specialists to support every stage of your project.',
    paragraph3: 'Our team is multilingual, fluent in English, Spanish, and Italian, ensuring seamless communication for clients from anywhere. At Art Throng, we combine creativity, expertise, and local knowledge to deliver spaces that are beautiful, functional, and tailored to your style and needs.',
    subtitle: 'Art Throng Home was born from a passion for creating beautiful, functional spaces. With years of experience in interior design and property management, we understand what it takes to maintain an impeccable home.',
    items: {
      expertise: {
        title: 'Interior Expertise',
        description: 'Our team combines design skills with practical home care knowledge',
      },
      staff: {
        title: 'Professional Staff',
        description: 'All team members are vetted, trained, and committed to excellence',
      },
      experience: {
        title: 'Premium Experience',
        description: 'Personalized attention and high-quality service in every interaction',
      },
    },
  },
  testimonials: {
    title: 'What Our Clients Say',
    subtitle: 'Real stories from transformed homes',
  },
  contact: {
    badge: 'Get In Touch',
    title: 'Let\'s Talk',
    subtitle: 'We\'re here to answer your questions and help you get started',
    form: {
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      subject: 'Subject',
      subjectPlaceholder: 'How can we help',
      message: 'Message',
      messagePlaceholder: 'Your message...',
      submit: 'Send Message',
      submitting: 'Sending...',
      success: 'Message sent successfully! We\'ll be in touch soon.',
      error: 'Something went wrong. Please try again.',
    },
    info: {
      phone: 'Phone',
      email: 'Email',
      location: 'Location',
      locationValue: 'Fuerteventura, Canary Islands',
    },
  },
  footer: {
    tagline: 'Transforming houses into beautiful homes',
    quickLinks: 'Quick Links',
    services: 'Services',
    packages: 'Packages',
    about: 'About',
    contact: 'Contact',
    followUs: 'Follow Us',
    copyright: 'All rights reserved.',
    poweredBy: 'Powered by Readdy',
  },
  renderService: {
    title: '3D Render Service',
    description: 'We provide a service of creating 3D renders for your house, apartment, villas, office and commercial spaces. Whether it\'s interior or exterior, our designers work with your requirements and deliver visualizations and detailed renders for you to be able to give a vision to your home or office.',
    howItWorks: 'How Does It Work?',
    pricing: 'Pricing',
    pricingDescription: 'The pricing starts from €350, but it differs according to the size, requirement and specificity of the renders. Please get in touch with us with your requirements.',
    getInTouch: 'Get in touch:',
    renderedProjects: 'Our Rendered Projects',
    steps: {
      send: {
        title: 'Send Requirements',
        description: 'Share your images, videos, floor plans, and preferred styles with references if possible.',
      },
      design: {
        title: 'Design & Create',
        description: 'Our designers study the material and create detailed 3D renders with multiple options.',
      },
      delivery: {
        title: 'Delivery',
        description: 'Receive your high-resolution renders in PDF format within one week.',
      },
    },
    priceRanges: [
      { range: '€250', description: 'Basic single room render' },
      { range: '€500', description: 'Standard multi-room project' },
      { range: '€1,000', description: 'Complete apartment/villa' },
      { range: '€1,500', description: 'Large commercial spaces' },
      { range: '& Above', description: 'Complex custom projects' },
    ],
    projects: {
      modernLiving: 'Modern Living Space',
      contemporary: 'Contemporary Interior',
      luxuryKitchen: 'Luxury Kitchen Design',
      officeSpace: 'Office Space Visualization',
    },
  },
  projectsCompleted: {
    title: 'Projects Completed',
    subtitle: 'Explore our portfolio of successfully completed projects across Corralejo, showcasing our expertise in transforming diverse spaces.',
    projects: {
      cafeBarista: 'Café Barista',
      supermercado: 'Supermercado Deseos',
      coliving: 'Coliving',
      luxuryTerrace: 'Luxury Terrace Design',
    },
    location: 'Corralejo',
  },
};